import * as React from 'react';
import classnames from 'classnames';
import CheckCircleFilled from '@ant-design/icons/CheckCircleFilled';
import CloseCircleFilled from '@ant-design/icons/CloseCircleFilled';
import ExclamationCircleFilled from '@ant-design/icons/ExclamationCircleFilled';
import WarningFilled from '@ant-design/icons/WarningFilled';
import { ConfigConsumer } from '../config-provider';
import devWarning from '../_util/devWarning';
import noFound from './noFound';
import serverError from './serverError';
import unauthorized from './unauthorized';
export const IconMap = {
    success: CheckCircleFilled,
    error: CloseCircleFilled,
    info: ExclamationCircleFilled,
    warning: WarningFilled,
};
export const ExceptionMap = {
    '404': noFound,
    '500': serverError,
    '403': unauthorized,
};
// ExceptionImageMap keys
const ExceptionStatus = Object.keys(ExceptionMap);
/**
 * render icon
 * if ExceptionStatus includes ,render svg image
 * else render iconNode
 * @param prefixCls
 * @param {status, icon}
 */
const renderIcon = (prefixCls, { status, icon }) => {
    const className = classnames(`${prefixCls}-icon`);
    if (process.env.NODE_ENV !== 'production')
        devWarning(!(typeof icon === 'string' && icon.length > 2), 'Result', `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${icon}\` at https://ant.design/components/icon`);
    if (ExceptionStatus.includes(`${status}`)) {
        const SVGComponent = ExceptionMap[status];
        return (<div className={`${className} ${prefixCls}-image`}>
        <SVGComponent />
      </div>);
    }
    const iconNode = React.createElement(IconMap[status]);
    return <div className={className}>{icon || iconNode}</div>;
};
const renderExtra = (prefixCls, { extra }) => extra && <div className={`${prefixCls}-extra`}>{extra}</div>;
const Result = props => (<ConfigConsumer>
    {({ getPrefixCls, direction }) => {
    const { prefixCls: customizePrefixCls, className: customizeClassName, subTitle, title, style, children, status, } = props;
    const prefixCls = getPrefixCls('result', customizePrefixCls);
    const className = classnames(prefixCls, `${prefixCls}-${status}`, customizeClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
    });
    return (<div className={className} style={style}>
          {renderIcon(prefixCls, props)}
          <div className={`${prefixCls}-title`}>{title}</div>
          {subTitle && <div className={`${prefixCls}-subtitle`}>{subTitle}</div>}
          {renderExtra(prefixCls, props)}
          {children && <div className={`${prefixCls}-content`}>{children}</div>}
        </div>);
}}
  </ConfigConsumer>);
Result.defaultProps = {
    status: 'info',
};
// eslint-disable-next-line prefer-destructuring
Result.PRESENTED_IMAGE_403 = ExceptionMap[403];
// eslint-disable-next-line prefer-destructuring
Result.PRESENTED_IMAGE_404 = ExceptionMap[404];
// eslint-disable-next-line prefer-destructuring
Result.PRESENTED_IMAGE_500 = ExceptionMap[500];
export default Result;
